import { render, staticRenderFns } from "./DetailNotif.vue?vue&type=template&id=0dec595c&"
import script from "./DetailNotif.vue?vue&type=script&lang=js&"
export * from "./DetailNotif.vue?vue&type=script&lang=js&"
import style0 from "./notification.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports